module.exports = __webpack_public_path__ + "img/106-panama.26e0ffa1.svg";